import { Box, Tag, TagColor } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type { Expensable } from 'modules/expenses/components/expenses/DataTable/types'

interface Category {
  expensable: Expensable['expense'] | Expensable['mileage'] | Expensable['perDiem']
}

export const Category = ({ expensable }: Category) => {
  return (
    <Box flexDirection="row" alignItems="center">
      <Tag type={TagColor.neutral}>
        {expensable?.category?.name ?? i18n.t('expenses_v2.expense.category.uncategorized')}
      </Tag>
    </Box>
  )
}
